// extracted by mini-css-extract-plugin
export default {"Toggle":"Toggle_Toggle__HL7ir","FirstButton":"Toggle_FirstButton__gJX8O","SecondButton":"Toggle_SecondButton__UiJ3r"};